import { Routes } from '@angular/router';
import { IsChromeGuard } from 'src/app/shared/services/guard/is-chrome.guard';
import { BREADCRUMB_LABEL_VALUE } from 'src/app/shared/models/breadcrumb';
import { ExpeditionManuelGuard } from 'src/app/shared/services/guard/expedition-manuel.guard';
import { ExpeditionAutoGuard } from 'src/app/shared/services/guard/expedition-auto.guard';
import { HomeGuard } from 'src/app/shared/services/guard/home.guard';
import { AssociationSortieVolGuard  } from 'src/app/shared/services/guard/association-sortie-vol.guard';
import { RechercheExpeditionGuard } from 'src/app/shared/services/guard/recherche-expedition.guard';
import { RechercheContenantsGuard } from "src/app/shared/services/guard/recherche-contenants.guard";

export const AppRoutingModule: Routes = [
  {
    path: 'notChrome',
    loadComponent: () => import('@cddng/auth-oidc-apim').then(component => component.AuthOidcUnauthorizedComponent),
    data: {
      message: 'Merci de bien vouloir utiliser le navigateur Chrome ou Edge Chromium!',
      aRoute: [ '/notChrome' ],
      aLabel: ' '
    }
  },
  {
    path: 'autologin',
    loadComponent: () => import('@cddng/auth-oidc-apim').then(component => component.AuthOidcAutoLoginComponent),
    data: {
      message: 'Vous allez être redirigé vers la mire de connexion I2A!'
    },
    canActivate: [ IsChromeGuard ]
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('@cddng/auth-oidc-apim').then(component => component.AuthOidcUnauthorizedComponent),
    data: {
      message: 'Attention! Vous n\'êtes pas autorisé à accéder à cette ressource!',
      aRoute: [ '/autologin' ],
      aLabel: 'Rafraîchir'
    },
    canActivate: [ IsChromeGuard ]
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home/home/home.component').then(component => component.HomeComponent),
    canActivate: [ IsChromeGuard, HomeGuard ]
  },
  {
    path: 'bienvenue',
    loadComponent: () => import('src/app/bienvenue/bienvenue.component').then(component => component.BienvenueComponent),
    canActivate: [IsChromeGuard]
  },
  {
    path: 'expedition-manuel',
    loadChildren: () => import('src/app/expedition-manuel/expedition-manuel-routing.module').then(mod => mod.ExpeditionManuelRoutingModule),
    data: { breadcrumb: BREADCRUMB_LABEL_VALUE.RECHERCHE },
    canActivate: [ IsChromeGuard, ExpeditionManuelGuard ]
  },
  {
    path: 'expedition-auto',
    loadChildren: () => import('./expedition-auto/expedition-auto-routing.module').then(mod => mod.ExpeditionAutoRoutingModule),
    data: { breadcrumb: BREADCRUMB_LABEL_VALUE.RECHERCHE },
    canActivate: [ IsChromeGuard, ExpeditionAutoGuard ]
  },
  {
    path: 'association-sortie-vol',
    loadChildren: () => import('./association-sortie-vol/supervision/supervision-routing.module').then(mod => mod.SupervisionRoutingModule),
    canActivate: [ IsChromeGuard, AssociationSortieVolGuard ]
  },
  {
    path: 'recherche-expeditions',
    loadChildren: () => import('./recherche-expeditions/supervision-recherche/supervision-recherche-routing.module').then(mod => mod.SupervisionRechercheRoutingModule),
    canActivate: [ IsChromeGuard, RechercheExpeditionGuard ]
  },
  {
    path: 'recherche-contenants',
    loadChildren: () => import('./recherche-contenants/supervision-recherche-contenants/supervision-recherche-contenant-routing.module').then(mod => mod.SupervisionRechercheContenantRoutingModule),
    canActivate: [ IsChromeGuard, RechercheContenantsGuard ]
  },
  {
    path: '**',
    redirectTo: 'bienvenue',
    pathMatch: 'full'
  }
];
